import { BookIcon } from '@/assets/SVGs/icons/BookIcon';
import BugIcon from '@/assets/SVGs/icons/BugIcon';
import ChatIcon from '@/assets/SVGs/icons/ChatIcon';
import { ReportShieldIcon } from '@/assets/SVGs/icons/ReportShieldIcon';
import { ticketType } from '@/types';

interface TicketIconTypeProps {
  type: ticketType;
}

export default function TicketIconType({ type }: TicketIconTypeProps) {
  if (type === ticketType.chat) return <ChatIcon />;
  else if (type === ticketType.bug) return <BugIcon />;
  else if (type === ticketType.user) return <ReportShieldIcon />;
  else if (type === ticketType.book) return <BookIcon />;
}
